import { CustomButton } from 'components/Button/CustomButton'
import CustomSpinner from 'components/Misc/CustomSpinner'
import { MainContext } from 'context/mainContext';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Button, Col, Container, CustomInput, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Modal, Row, Table } from 'reactstrap'
import { evaThemeLighter } from 'services/EVAResponseService';
import { registerDashboardTemplate } from 'services/mongoDB';
import { dashboardTemplate } from 'services/mongoDB';
import ReactBSAlert from "react-bootstrap-sweetalert";
import DashboardTemplateItem from './DashboardTemplateItem';
import DashboardTemplateItemModal from './DashboardTemplateItemModal';
import PanelCard from 'components/Cards/PanelCard';
import { useHistory } from "react-router";
import DashboardTemplateKPI from './DashboardTemplateKPI';
import { submitEvaQueryHandler } from 'services/DashboardService';
import { forEach, wrap } from 'lodash';
import { generateUUID } from 'services/EVAService';
import ManageDashboardDnD from '../manageDashboard/ManageDashboardDnD';
import EVAVisualEditDashboard from '../manageDashboard/EVAVisualEditDashboard';
import { userDashboardTemplate } from 'services/mongoDB';
import { userDashboardTemplateByUser } from 'services/mongoDB';
import { getCustomGroups } from 'services/mongoDB';
import Select from 'react-select';
import { registerGroupNotification } from 'services/mongoDB';
import SendMultiDeviceNotification from 'services/NotificationService';
import SendExpoNotifications from 'services/ExpoNotificationService';
import { mongoFetchToken } from 'services/mongoDB';
import { etaniDashboardTemplates } from 'services/mongoDB';
// import socket from 'services/MainSocket';
// import socket from 'chat-components/utils/socket';
import XBImage from '../../../assets/img/XB.png';
import XPMImage from '../../../assets/img/XPM.png';
import WFMImage from '../../../assets/img/WFM2.png'
import { updateEtaniDashboardTemplates } from 'services/mongoDB';
import EVAChatDashboard from 'eva-component/EVAChatDashboard';
import DashboardTemplateDashboardList from './DashboardTemplateDashboardList';
import BlockUI from 'components/Misc/BlockUI';
import { IconDashboard } from 'eva-component/ui/icon';
import { dashboardDataStorage } from 'services/DashboardService';
import { decryptAndDecompress } from 'services/DashboardService';
import { GetCardItem } from 'services/EVAVisualService';
import { defaultCardColor } from 'services/EVAVisualService';
import { IconBar2 } from 'eva-component/ui/icon';
import { IconMenu } from 'eva-component/ui/icon';
import DashboardAnalyzerSetting from './DashboardAnalyzerSetting';
import EVADashboard from 'eva-component/EVADashboard';
import EVATemplates from 'eva-component/EVATemplates';
import { IconFolder } from 'eva-component/ui/icon';
import { IconAskEVA } from 'eva-component/ui/icon';
import { IconBuilder } from 'eva-component/ui/icon';
import socket from 'chat-components/utils/socket';
import socketServer from 'services/MainSocket';

function DashboardTemplate({ ...props }) 
{
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState(false);
    // const [templateList, setTemplateList] = useState(null)
    const [selectedTemplateItem, setSelectedTemplateItem] = useState([]);
    const [newDashboardName, setNewDashboardName] = useState('');
    const [tabKey, setKey] = useState(null);
    const [dashboardType, setDashboardType] = useState('New');
    const [KPITabKey, setKPITabKey] = useState(null);
    const [templates, setTemplates] = useState([])
    const [integration, setIntegration] = useState([])
    const [categories, setCategories] = useState([])
    const [sub_category, setSubCategories] = useState([])
    const [category_sub_category, setCategorySubCategories] = useState([])
    const [sqlExampleResult, setSQLExampleResult] = useState([])
    const [filteredSqlExampleResult, setFilteredSQLExampleResult] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    const [onEditVisual, setOnEditVisual] = useState(false)
    const [onEditItem, setOneditItem] = useState(null)
    const [onEditItemIndex, setOneditItemIndex] = useState(null)
    const [newUpdateCount, setNewUpdateCount] = useState(0);
    const [userTemplatesList, setUserTemplateList] = useState([])
    const [selectedExistingDashboard, setSelectedExistingDashboard] = useState(null)
    const [pintoDashboard, setPintoDashboard] = useState('personal');
    const [selectedGroupId, setSelectedGroupId] = useState([]);
    const [groupList, setGroupList] = useState([])
    const [customGroupList, setCustomGroupList] = useState(null)
    const [clientUsers, setClientUsers] = useState([]);
    const [selectGroupUsers, setSelectGroupUsers] = useState(null)
    const [defaultSelectedGroup, setDefaultSelectedGroup] = useState(null)
    const [etaniTemplates, setEtaniTemplates] = useState([])
    const [selectedEtaniTemplates, setSelectedEtaniTemplates] = useState(null)
    const [toggleShowSettings, setToggleShowSettings] = useState(true)
    const [includesEmail, setIncludesEmail] = useState(false)
    const [evaDateFilters, setEVADateFilters] = useState([])
    const [evaUUID, setEVAUUID] = useState(null)
    const [KPIList, setKPIList] = useState([])
    const [evaQuery, setEVAQuery] = useState(null)
    const [showBlockUI, setShowBlockUI] = useState(false);
    const [originalSelectedTemplateData, setOriginalSelectedTemplateData] = useState([])
    const [isHaveChanges, setIshavechanges] = useState(false)
    const [isLayoutChanges, setIsLayoutChanges] = useState(0)
    const [finalSelectedTemplateItem, setFinalSelectedTemplateItem] = useState([])
    const [dateRangesUpdate, setDateRangesUpdate] = useState(0)
    const [activeTabIndex, setActiveTabIndex] = useState(0)
    const [isAllowEVAtoAnalyse, setIsAllowEVAtoAnalyse] = useState(false)

    const {
        bgColor,
        textColor,
        selectedClientID,
        userDetails,
        firmDetails,
        isTemplateEdit,
        selectedTemplatetoEdit, 
        selectedClient,
        selectClientIntegration,
        setSelectedTemplatetoEdit, 
        setIsTemplateEdit,
        userAllDashboardList, 
        setContextUserAllDashboardList,
        groupDashboardTemplatesList, 
        setContextGroupDashboardTemplatesList,
        integrationLastRefreshList,
        templateFinalSelectedTemplateItem, 
        setTemplateFinalSelectedTemplateItem
    } = useContext(MainContext);

    
    const history = useHistory();
    const isInitialMount = useRef(true)
    useEffect(() => {
        const email = userDetails?.User?.Email.toLowerCase()
        const specialEmails = [
            "jp@etani.com.au", 
            "fuhad@etani.com.au", 
            "admin@etani-bp.com.au"
        ];
        setIncludesEmail(specialEmails.includes(email))
        
        const loadEVAUUID = async () => {
            const evaUUID = await generateUUID()
            setEVAUUID(evaUUID)
        }

        if(!evaUUID)
            loadEVAUUID()
    },[userDetails])
    useEffect(() => {
        // Cleanup function to handle unmounting
        return () => {
            setShowBlockUI(false);
            setIsLoading(false);
            setEVADateFilters([]);
            setKPIList([]);
            setSQLExampleResult([]);
            setFilteredSQLExampleResult([]);
            setEtaniTemplates([]);
            setSelectedEtaniTemplates(null);
            setOriginalSelectedTemplateData([]);
            setIshavechanges(false);
        };
    }, []);
    useEffect(( ) => {
        if(finalSelectedTemplateItem.length === 0) return
        finalSelectedTemplateItem.map(item => {
            // console.log(item)
        })
    },[finalSelectedTemplateItem])
    useEffect(() => {
        if(!evaUUID || !selectedClientID || Object.keys(userDetails).length === 0) return
            processSuggestedDashboard(evaUUID, selectedClientID, userDetails)
    },[evaUUID, selectedClientID, userDetails])

    useEffect(()=> {
        const loadTemplates = async () => {
            // const template = await dashboardTemplate()
            // console.log(firmDetails)
            try{
                setIsLoading(true)
                const res = await submitEvaQueryHandler(`SELECT * FROM _eva_sql_templates WHERE template IS NOT null ORDER BY order_no`, selectedClient, firmDetails, userDetails);
                const eva_date_filter = await submitEvaQueryHandler(`SELECT * FROM _eva_date_filters WHERE category IS NOT NULL AND category != ''`, selectedClient, firmDetails, userDetails);
                setEVADateFilters(eva_date_filter)
                setTemplateFinalSelectedTemplateItem([])
                if(res === undefined || !res) return // history.push(`/client/customDashboard`)
                const newRes = convertWFMtoXPM(res)

                const integrationNames = selectClientIntegration && selectClientIntegration.map(item => item.integration);
              
                const filteredDashboards = integrationNames ? newRes && newRes.filter(dashboard => integrationNames.includes(dashboard.integration)) : [];

                setKPIList(filteredDashboards)

                getTemplates(filteredDashboards)
                const groupedData = groupBy(filteredDashboards, 'template', 'integration', 'category');
                const transformedData = Object.entries(groupedData).map(([key, value]) => {
                    const [template, integration, category] = key.split('-');
                    return {
                        template,
                        integration,
                        category,
                        // details: value.map(item => ({
                        //     sub_category: item.sub_category,
                        //     display_name: item.display_name,
                        //     query: item.query,
                        //     visual_type: item.visual_type,
                        //     visual_data: parseVisualData(item.visual_data) 
                        // }))
                        details: groupBySubCategory(value)
                    };
                });
              
                const etaniTemplate = await etaniDashboardTemplates()
                
                setEtaniTemplates(etaniTemplate)
                setSQLExampleResult(transformedData);
                setFilteredSQLExampleResult(transformedData)
                setIsLoading(false)
            }catch(error)
            {
                console.log(error)
                setIsLoading(false)
            }

            // 
        }
        loadTemplates()
    }, [selectedClient, firmDetails, userDetails, selectClientIntegration, selectedClientID])
    let loadEVACount = 0
    const processSuggestedDashboard = useCallback(async (evaUUID, selectedClientID, userDetails) => {
        if(loadEVACount > 0) return
        loadEVACount++
        const raw = {
            "chatId": evaUUID,
            "query": "dashboard mode, Can you suggest dashboard items for my company?",
            "UserInfo": {
                "chatId": evaUUID,
                "UserId": userDetails.User.UserID,
                "Name": userDetails.User.FirstName,
                "ClientId": selectedClientID,
                "BusinessId": firmDetails.AccountingFirmID 
            }
        };
        try {
            const response = await fetch('https://evabetaprod.azurewebsites.net/eva_stream', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(raw)
            });
            
            const reader = response.body.getReader();
            let chunks = '';
            const streamMessageArray = []

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks += new TextDecoder().decode(value);
                const messagesArray = chunks.split('\n');
                streamMessageArray.push(chunks)
            }

            const newMessage = {
                uuid: evaUUID,
                clientid: selectedClientID,
                userid: userDetails.User.UserID,
                _id: Math.floor(Math.random() * 10000000000000),
                text: streamMessageArray[streamMessageArray.length - 1],
                sender: userDetails.User.UserID,
                user: {            
                    _id: Math.floor(Math.random() * 10000000000000),
                    sender: Math.floor(Math.random() * 10000000000000),
                    name: "EVA"
                },
                createdAt: new Date(),
                isDefaultDashboard: true
            }
        
            handleEVADashboardMessage(newMessage)
        } catch (error) {
            console.log(error)
            setIsLoading(false)
        }
    },[evaUUID])
    const convertWFMtoXPM = (res) => {
        const removedWFM = res && res.filter(i => i.integration !== "WFM");
        const XPMList = res && res.filter(i => i.integration === "XPM");

        const WFMList = XPMList.map((item) => {
            return {
                ...item,
                integration: "WFM",
                query: item.query
                    .replace(/_xpm/g, "_wfm2")
                    .replace(/_wfm2transactions/g, "_wfm2_eva_transactions"),
                dynamic_query: item?.dynamic_query ? item?.dynamic_query
                    .replace(/_xpm/g, "_wfm2")
                    .replace(/_wfm2transactions/g, "_wfm2_eva_transactions") : null,
            };
        });

        const combinedList = [...removedWFM, ...WFMList];
    
        const sortedList = combinedList.sort((a, b) => {
            if (a.intergrationid === null) return 1;
            if (b.intergrationid === null) return -1;
            return a.intergrationid - b.intergrationid;
        });
    
        return sortedList
    }
    const handleSelectedTemplatetoEdit = useCallback((data) => {
        setOriginalSelectedTemplateData(data)
    },[selectedTemplatetoEdit])
    const getTemplates = (res) => {
        const templates = []
        const integration = []
        const categories = []
        const newData = []
        const sub_category = []
        const category_sub_category = []
        // console.log(res)
        if (res && res.length > 0) {
            const templatesSet = new Set();
            const integrationSet = new Set();
            const categoriesSet = new Set();
            const subCategorySet = new Set();
            const categorySubCategorySet = new Set();
            
            res.forEach(item => {
                if (!templatesSet.has(item.template)) {
                    templatesSet.add(item.template);
                    templates.push(item.template);
                }
        
                if (!integrationSet.has(item.integration)) {
                    integrationSet.add(item.integration);
                    integration.push(item.integration);
                }
        
                if (!categoriesSet.has(item.category)) {
                    categoriesSet.add(item.category);
                    categories.push(`${item.integration}-${item.category}`);
                }
        
                if (item.sub_category && !subCategorySet.has(item.sub_category)) {
                    subCategorySet.add(item.sub_category);
                    sub_category.push(item.sub_category);
                }
        
                const categorySubKey = `${item.category} | ${item.sub_category}`;
                if (item.category && item.sub_category && !categorySubCategorySet.has(categorySubKey)) {
                    categorySubCategorySet.add(categorySubKey);
                    category_sub_category.push({ 
                        category_sub_category: item.category, 
                        sub_category: item.sub_category 
                    });
                }
            });
        }

        if(!tabKey) setKey(integration[0])
        // categories.sort((a, b) => a.localeCompare(b));

        setTemplates(templates)
        setIntegration(integration)
        setCategories(categories)
        setSubCategories(sub_category)
        setCategorySubCategories(category_sub_category)
    }
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            // history.push(`/client/customDashboard`);
        }
    }, [selectedClientID, history]);

    useEffect(() => {
        loadUserTemplate()
        loadClientUser(selectedClient?.id)
    },[selectedClientID, selectedClient])
    
    useEffect(() => {
        const handleResize = () => {
          setScreenHeight(window.innerHeight);
        };
    
        window.addEventListener('resize', handleResize);
        handleSelectedTemplatetoEdit(selectedTemplatetoEdit)
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, [selectedTemplatetoEdit]);
    const loadClientUser = async (selectedClientID) => {
        if(!selectedClientID || selectedClientID === undefined) return

        await fetch(`/api/user/getAllRecords/${selectedClientID}`)
        .then((res) => res.json())
        .then((data) => {
            if (data && !data.error) {
                const users = []
                data.map((user) => users.push(user.Email));
                setClientUsers(users);
            } else {
                setIsLoading(false)
                return;
            }
        })
        .catch((err) => {
            console.log(err);
        });
    }
    const loadUserTemplate = async () => 
    {
        if (Object.keys(userDetails).length === 0) return false;

        const param = {
            clientId: selectedClientID,
            user: userDetails.User.Email
        }
        const res = await userDashboardTemplateByUser(param)

        const publicTemplate = res.filter((item) => item.userAccessSetting?.accessType === 'public'
            && (item.userAccessSetting?.clientOption === "All Client" || item.userAccessSetting?.selectedClient?.some(client => client.ClientID === selectedClientID))
            && item.businessId === firmDetails.AccountingFirmID
        )

        setUserTemplateList(publicTemplate)
    }
    const fetchClientGroups = async () => {
        if(pintoDashboard === 'personal') return
        const res = await getCustomGroups({ ClientId: selectedClientID, email: userDetails.User.Email })
        setCustomGroupList(res)

        const users = []
        selectedClient && selectedClient.User && selectedClient.User.map(item => users.push(item.Email))
        const groups = [{
            "id": selectedClient.ClientID,
            "Users": users,
            "GroupName": selectedClient.Name,
            "ClientId": selectedClient.ClientID
        }]
        const newRes = groups.map(item => { return { value: item.id, label: item.GroupName } }).concat(res.map(item => {return { value: item.id, label: item.GroupName }}))
        setGroupList(newRes);
    };
    const parseVisualData = (visualData) => {
        try {
            const data = JSON.parse(visualData) 
            return data
        }catch(error){
            return []
        }
    }
    const groupBy = (array, ...keys) => {
        return array.reduce((acc, obj) => {
            const key = keys.map(key => obj[key]).join('-');
            (acc[key] = acc[key] || []).push(obj);
            return acc;
        }, {});
    };
    const groupBySubCategory = (array) => {
        array.sort((a, b) => {
            if (a.sub_category < b.sub_category) return -1;
            if (a.sub_category > b.sub_category) return 1;
            return 0;
        });
        const newData = []
        const groupedData = array.reduce((acc, item) => {
            const { sub_category, display_name, query, visual_type, visual_data, dynamic_query, my_row_id } = item;
            
            let existingEntry = newData.find(entry => entry.sub_category === sub_category ? sub_category : '');
            if(existingEntry) {
                existingEntry.details.push({
                    my_row_id: my_row_id,
                    display_name: display_name,
                    query: query,
                    dynamic_query: dynamic_query,
                    visual_type: visual_type,
                    visual_data: parseVisualData(visual_data) 
                })
            } else {
                existingEntry = { sub_category, details: [{
                    my_row_id: my_row_id,
                    display_name: display_name,
                    query: query,
                    dynamic_query: dynamic_query,
                    visual_type: visual_type,
                    visual_data: parseVisualData(visual_data) 
                }] };
                newData.push(existingEntry);
            }

            // console.log(sub_category)
            // if (!acc[sub_category]) {
            //   acc[sub_category] = [];
            // }
            // acc[sub_category].push(item);

            return acc;
        }, {});
        return newData
    }
    useEffect(() => {
        const loadTemplates = async () => {
            if(isTemplateEdit)
            {
                setShowBlockUI(true)
                setIsEtaniTemplate(false)
                setNewDashboardName('')
                setSelectedTemplateIntegration(null)
                setSelectedTemplateItem([])
                setDefaultSelectedGroup(null)
                setToggleShowSettings(false)
                setTimeout(() => {
                    const selectedTemplate = selectedTemplatetoEdit ? selectedTemplatetoEdit : templateFinalSelectedTemplateItem
                    if(selectedTemplate.isEtaniTemplate) 
                    {
                        setIsEtaniTemplate(selectedTemplate.isEtaniTemplate)
                        setNewDashboardName(selectedTemplate.name.split("-")[0])
                        setSelectedTemplateIntegration(selectedTemplate.name.split("-")[1])
                    } else {
                        setPintoDashboard(selectedTemplate.isPersonalDashboard ? 'personal' : 'group')
                        setNewDashboardName(selectedTemplate.name)
                    }

                    setIsAllowEVAtoAnalyse(selectedTemplate.isAllowEVAtoAnalyse)
                    selectedTemplate?.dashboardTemplate && selectedTemplate?.dashboardTemplate.map((item) => {
                        const findItem = KPIList.find(e => e.my_row_id === item.my_row_id)
                        item.dynamic_query = findItem?.dynamic_query || item.query
                        item.final_dynamic_query = item.query
                    })

                    setTemplateFinalSelectedTemplateItem([])
                    setSelectedTemplate(selectedTemplate)
                    setSelectedTemplateItem(selectedTemplate.dashboardTemplate)
                    setShowBlockUI(false)
                }, 500);
            }else{
                setTemplateFinalSelectedTemplateItem([])
                setToggleShowSettings(true)
                setShowBlockUI(false)
                setNewDashboardName('')
                setSelectedTemplateIntegration(null)
                setSelectedTemplateItem([])
                setDefaultSelectedGroup(null)
                return
            }
        }
        loadTemplates()
    },[KPIList, selectedTemplatetoEdit])

    useEffect(() => {
        const groupsIds = (selectedTemplatetoEdit?.selectedGroupId?.groupsId || []).map(item => {
            return groupList.find(group => group.value === item);
        }).filter(group => group !== undefined);                

        setDefaultSelectedGroup(groupsIds);
        handleSelectGroupChange(groupsIds)
    },[groupList])
    const handleDateRangesUpdate = () => {
        setDateRangesUpdate(prev => prev + 1)
    }
    useEffect(() => {
        if (!selectedTemplateItem || selectedTemplateItem.length === 0) 
        {
            setTemplateFinalSelectedTemplateItem([])
            setFinalSelectedTemplateItem([])
            return;
        }
        const originalFinalSelectedTemplateItem = templateFinalSelectedTemplateItem

        const processItems = async () => {
            const newDataSet = [];
            setIsLoading(true)
            let i = 0
            for (const item of selectedTemplateItem) {
                const isSeparateCardItem = originalFinalSelectedTemplateItem ? originalFinalSelectedTemplateItem.filter(i => i.my_row_id === item.my_row_id) : []
                if (item.visual_type === "Card" && (!isSeparateCardItem[0]?.isSeparateCard || isSeparateCardItem[0]?.final_dynamic_query || item.stext)) {
                    if(isSeparateCardItem[0]?.final_dynamic_query) {
                        item.final_dynamic_query = isSeparateCardItem[0]?.final_dynamic_query
                        item.dateRanges = isSeparateCardItem[0]?.dateRanges
                    }
                    await processCardViewItems(item, newDataSet, i, isSeparateCardItem);
                    i++;
                } else if (item.visual_type === "Card" && isSeparateCardItem[0]?.isSeparateCard) {
                    isSeparateCardItem.map(i => {   
                        newDataSet.push(i);
                    })
                    i++;
                } else {
                    newDataSet.push(item);
                }
            }

            setIsLoading(false)
            setTemplateFinalSelectedTemplateItem(newDataSet)
            setFinalSelectedTemplateItem(newDataSet)
    
            if (selectedTemplateItem.length === 1) {
                setKPITabKey(selectedTemplateItem[0].name);
                return;
            }
    
            if (!KPITabKey) {
                setKPITabKey(selectedTemplateItem[0].name);
                return;
            }
    
            const index = selectedTemplateItem.findIndex((prevItem) => prevItem.name === KPITabKey.name);
            if (index < 0 && selectedTemplateItem.length > 0) {
                setKPITabKey(selectedTemplateItem[0].name);
            }
        };
        
        processItems();
    }, [selectedTemplateItem, newUpdateCount, dateRangesUpdate]);
    const processCardViewItems = async (item, newDataSet, index, isSeparateCardItem) => {
        try {
            let res;
            const lastRefreshData = integrationLastRefreshList.find(i => i.integration === item.integration);
            const refreshDate = lastRefreshData?.lastRefresh ?? new Date().toLocaleString();
            const cached = dashboardDataStorage(item, refreshDate);

            if (cached) {
                res = cached;
            } else {
                if (item.stext !== undefined) {
                    const decryptedText = await decryptAndDecompress(item.stext);
                    res = await submitEvaQueryHandler(decryptedText, selectedClient, firmDetails, userDetails, item, 0);
                } else {
                    res = await submitEvaQueryHandler(item.final_dynamic_query || item.dynamic_query || item.query, selectedClient, firmDetails, userDetails, item, 0);
                }
            }
    
            const header = res.length > 0 ? Object.keys(res[0]) : [];
            const cleanedHeader = header.map(h => h.replace(/\s*\[.*?\]/g, ''));
            const sqlresult = res.map(obj => Object.values(obj));
            const originalItem = { ...item };
            
            const cardVisual = await GetCardItem(cleanedHeader, sqlresult, item);
            if (cardVisual && Array.isArray(cardVisual.cardItem) && cardVisual.cardItem.length > 0) {
                if(cardVisual.cardItem.length === 1) {
                    item.cleanedHeader = cleanedHeader
                    newDataSet.push(item);
                    return
                }
                cardVisual.cardItem.forEach((card, idx) => {
                    const itemClone = { ...originalItem };
                    const dimension = isSeparateCardItem && isSeparateCardItem[idx]?.tempVisual || originalItem?.tempVisual?.cardItem[idx] || originalItem?.visual?.cardItem[idx] 
                    if(idx !== 0 || cardVisual.cardItem.length === 1) {
                        delete itemClone.query; 
                        delete itemClone.dynamic_query;
                        delete itemClone.final_dynamic_query;
                        delete itemClone.visual;
                    }

                    // Set the base visual properties
                    itemClone.tempVisual = {
                        ...cardVisual,
                        cardItem: [card]
                    };

                    // if(isSeparateCardItem && isSeparateCardItem[idx]?.tempVisual) {
                    //     const { tempVisual } = isSeparateCardItem[idx];
                    if(dimension)
                        itemClone.tempVisual = {
                            ...itemClone.tempVisual,
                            height: dimension.height,
                            width: dimension.width,
                            x: dimension.x,
                            y: dimension.y
                        };
                    // }
                    
                    itemClone.__cardIndex = idx;
                    itemClone.cardTitle = card.column;
                    itemClone.isSeparateCard = true;
                    itemClone.sqlresult = sqlresult;
                    itemClone.cleanedHeader = cleanedHeader;
                    itemClone.gridHeaderDateRange = header;
                    itemClone.background = defaultCardColor(index)
                    newDataSet.push(itemClone);
                });
            } else {
                item.visual_type = "Grid"
                newDataSet.push(item);
            }
    
        } catch (error) {
            console.error(error);
            newDataSet.push(item);
        }
    };

    const handleNewDashboardNameChange = (event) => {
        setNewDashboardName(event.target.value);
    };
    const handleRemoveKPI = async (my_row_id) => {
        removeSelectedTemplateItem(my_row_id)
        setSelectedTemplateItem((prevItems) => {
            const index = prevItems.findIndex((prevItem) => prevItem.my_row_id === my_row_id);
            if (index > -1) {
                const updatedItems = [...prevItems];
                updatedItems.splice(index, 1);
                return updatedItems;
            } else {
                return [...prevItems];
            }
        });
    }
    const handleSelectItem = async (item) => {
     
        item.uid = await generateUUID();
        setSelectedTemplateItem((prevItems) => {
            const index = prevItems.findIndex((prevItem) => prevItem.my_row_id === item.my_row_id);
            if (index > -1) {
                removeSelectedTemplateItem(item.my_row_id)
                const updatedItems = [...prevItems];
                updatedItems.splice(index, 1);
                return updatedItems;
            } else {
                return [...prevItems, item];
            }
        });
    }
    const removeSelectedTemplateItem = (my_row_id) => {
        const originalSelectedTemplateItem = templateFinalSelectedTemplateItem
        const newSelectedTemplateItem = originalSelectedTemplateItem.filter(i => i.my_row_id !== my_row_id)
        setTemplateFinalSelectedTemplateItem(newSelectedTemplateItem)
    }
    const handleSave = async () => 
    {
        if(pintoDashboard !== 'personal' && (selectedGroupId.length === 0 || !selectedGroupId))
        {
            warningAlert("Please select a Group!");
            return
        }

        if(isEtaniTemplate && !selectedTemplateIntegration) {
            warningAlert("Please select Integration!");
            return
        }

        const originalSelectedTemplateItem = templateFinalSelectedTemplateItem
        const dashboardItem = []
        selectedTemplateItem.map(item => {
            if(item.visual_type === 'Card') {
                const existingItem = originalSelectedTemplateItem.filter(i => i.my_row_id === item.my_row_id)
                if(existingItem) {
                    const item = existingItem[0]

                    if(item.tempVisual) {
                        item.tempVisual.cardItem = existingItem.map(i => {
                            return {
                                ...i.tempVisual.cardItem[0],
                                x: i.tempVisual.x,
                                y: i.tempVisual.y,
                                width: i.tempVisual.width,
                                height: i.tempVisual.height
                            }
                        })
                        dashboardItem.push(item)
                    } else if(item.visual) {
                        item.visual.cardItem = existingItem.map(i => i.tempVisual.cardItem[0])
                        dashboardItem.push(item)
                    }
                }
            } else {
                dashboardItem.push(item)
            }
        })

        if(selectedTemplateItem.length > 0 && newDashboardName)
        {
            let param = {
                name: isEtaniTemplate ? `${newDashboardName}-${selectedTemplateIntegration}` : newDashboardName,
                clientId: selectedClientID,
                businessId: firmDetails.AccountingFirmID,
                groupId: selectedClientID,
                user: userDetails.User.Email,
                isPersonalDashboard: isEtaniTemplate ? isEtaniTemplate : pintoDashboard === 'personal',
                selectedGroupId: { groupsId: selectedGroupId },
                isEtaniTemplate: isEtaniTemplate,
                isAllowEVAtoAnalyse: isAllowEVAtoAnalyse,
                dashboardTemplate: dashboardItem.map(item => ({
                    ...item,
                    visual: item.tempVisual || item.visual,
                    editedGridCellData: item.editedGridCellData
                })),
                uid: selectedEtaniTemplates?.uid ? selectedEtaniTemplates.uid : ''
            };
            
            param.dashboardTemplate.forEach(item => {
                delete item.tempVisual;
            });
            
            // console.log("selectedEtaniTemplates: ", selectedEtaniTemplates)
            param.dashboardTemplate = param.dashboardTemplate.map(template => {
                return {
                    ...template,
                    query: template.final_dynamic_query || template.query,
                    final_dynamic_query: undefined,
                    dynamic_query: undefined
                };
            });
            
            // Remove undefined properties
            param.dashboardTemplate = param.dashboardTemplate.map(({ final_dynamic_query, dynamic_query, query, ...rest }) => rest);

            // console.log(param)
            // return

            if(isTemplateEdit)
            {
                param.id= selectedTemplatetoEdit.id
                registerDashboardTemplate(param)
                if(pintoDashboard !== 'personal' && !isEtaniTemplate)
                    sendNotificationPerGroup(isTemplateEdit, newDashboardName)
                const alertMessage = `You have successfully update ${newDashboardName}`
                handleSuccessUpdate(alertMessage)
            }else{
                registerDashboardTemplate(param)
                const alertMessage = `You have successfully add ${newDashboardName}`
                if(pintoDashboard !== 'personal')
                    sendNotificationPerGroup(isTemplateEdit, newDashboardName)
                handleSuccessUpdate(alertMessage)
            }
        }else{
            if (!selectedTemplateItem && selectedTemplateItem.length === 0) warningAlert("You need to add at least one item!");
            if (!newDashboardName) warningAlert("The dashboard name is invalid!");
        }
    }
    const handleImportTemplate = async () => 
    {
        let param = {
            name: newDashboardName,
            clientId: selectedClientID,
            businessId: firmDetails.AccountingFirmID,
            groupId: selectedClientID,
            user: userDetails.User.Email,
            dashboardTemplate: selectedTemplateItem.map(item => ({
                ...item,
                visual: item.tempVisual
            })),
            importedTemplate: true
        };
        
        param.dashboardTemplate.forEach(item => {
            delete item.tempVisual;
        });

        try{
            registerDashboardTemplate(param)
            const alertMessage = `You have successfully add ${newDashboardName}`
            handleSuccessUpdate(alertMessage)
        } catch(error) {
            const alertMessage = `An error occured while saving the template`
            warningAlert(alertMessage)
        }
    }
     const warningAlert = (message) => {
        setAlert(
        <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Warning"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="warning"
            confirmBtnText="Ok"
            btnSize=""
        >
            {message}
        </ReactBSAlert>
        );
    };
    const handleSuccessUpdate = (msg, data) => {
        setAlert(
            <ReactBSAlert
                succes
                title="Success"
                onConfirm={async () => {
                    setAlert(null)
                    setTemplateFinalSelectedTemplateItem([])
                    history.push(`/client/customDashboard`);
                }}
                confirmBtnBsStyle="success"
                confirmBtnText="Ok"
                btnSize=""
            >
                <>
                    <p>
                        {msg}
                    </p>
                </>
            </ReactBSAlert>
        );
    }
    const handleSelectExistingTemplate =  useCallback((item) => {
        setNewDashboardName(item.name)
        setSelectedExistingDashboard(item.id)
        setSelectedTemplateItem([]);
        
        setTimeout(() => {
            setSelectedTemplateItem(item.dashboardTemplate);
        }, 200);

    }, []);
    const handleSelectTemplate =  async(item, selectedTemplate) => {
        setSelectedTemplate(null);
        setSelectedTemplateItem([]);

        setTimeout(async () => {
            if (selectedTemplate === item) {
                setSelectedTemplate(null);
                setSelectedTemplateItem([]);
            } else {
                const newSelectedTemplateItem = [];
                const filterByTemplate = sqlExampleResult.filter((e) => e.template === item);
        
                for (const e of filterByTemplate) {
                    if (e.template === item) {
                        const details = e.details;
                        for (const detail of details) {
                            const uid = await generateUUID();
                            newSelectedTemplateItem.push({ 
                                name: detail.display_name, 
                                query: detail.query, uid, 
                                visual_type: detail.visual_type, 
                                visual_data: detail.visual_data,
                                integration: item.integration
                            });
                        }
                    }
                }
                setSelectedTemplate(item);
                setSelectedTemplateItem(newSelectedTemplateItem);
            }
        }, 300);
    };
    const handleSelectEtaniTemplate =  async(selectedTemplate) => {
       
        if(selectedTemplate.id === selectedEtaniTemplates?.id){
            setSelectedTemplateItem([])
            setNewDashboardName('')
            setSelectedEtaniTemplates(null)
        }else{
            setSelectedTemplateItem([])
            setNewDashboardName('')
            setSelectedEtaniTemplates(null)
            setTimeout(() => {
                const templateKPI = [...selectedTemplate.dashboardTemplate]
                const KPIDataSet = []

                sqlExampleResult.map(template => {
                    template.details.map(category => {
                        category.details.map(details => {
                            KPIDataSet.push(details)
                        })
                    })
                })

                const updatedTemplateKPI = templateKPI.map(kpi => {
                    const item = KPIDataSet.find(i => i.display_name === kpi.name);
                    if (item && kpi.query !== item.query) {
                        // Return the updated item
                        return item;
                    }
                    // Return the original kpi if no changes are needed
                    return kpi;
                });
                
                // console.log(updatedTemplateKPI);
                

                setNewDashboardName(selectedTemplate.name.split("-")[0])
                setSelectedTemplateItem(templateKPI)
                setSelectedEtaniTemplates(selectedTemplate)
            }, 100);
        }
    };
    const handleSelectCategory = useCallback(async (checked, value) => {
        let newItems = [...finalSelectedTemplateItem];
        for (const item of value.details) {
            for (const e of item.details) {
                const exists = finalSelectedTemplateItem.some(item => item.name === e.display_name);
            
        
                if (exists && !checked) {
                    // Remove item if it exists and should be unchecked
                    newItems = newItems.filter(item => item.name !== e.display_name);
                } else if (!exists && checked) {
                    // Add item if it does not exist and should be checked
                    const newItem = {
                        uid: await generateUUID(),
                        my_row_id: e.my_row_id,
                        name: e.display_name,
                        query: e.query,
                        dynamic_query: e.dynamic_query,
                        visual_type: e.visual_type,
                        visual_data: e.visual_data,
                        integration: value.integration
                    };
                    newItems.push(newItem);
                }
            }
        }
        setSelectedTemplateItem(newItems);
    }, [selectedTemplateItem]);
    
    const handleSelectDashboardType = useCallback((value) => {
        setNewDashboardName(null)
        setSelectedExistingDashboard(null)
        setSelectedTemplateItem([]);
        setDashboardType(value)
    }, []);
    const handleTabSelect = useCallback((value) => {
        setKey(value)
    }, []);
    const handleOnEditVisual = (index, evaQuery) => {
        const selectedItem = selectedTemplateItem.find(item => item.my_row_id === index)

        if(selectedItem.visual_type === 'Card') {
            const originalSelectedItem = templateFinalSelectedTemplateItem
            if(originalSelectedItem[0].cleanedHeader > 1) {
                const originalSelectedItemIndex = originalSelectedItem.filter(item => item.my_row_id === index)
                const cardItem = originalSelectedItemIndex.map(item => item.tempVisual.cardItem[0])
                selectedItem.tempVisual = originalSelectedItemIndex[0].tempVisual
                selectedItem.tempVisual.cardItem = cardItem
            }
        }

        setEVAQuery(selectedItem.final_dynamic_query || selectedItem.dynamic_query)
        setOnEditVisual(!onEditVisual)
        setOneditItem(selectedItem)
        setOneditItemIndex(index)
    }

    const handleCloseEditVisual = () => {
        setOnEditVisual(false)
        // setNewUpdateCount(prevCount => prevCount + 1);
    }
    useEffect(() => {
    },[newUpdateCount, evaQuery])
    const handleSelectPinToDashboard = async (event) => {
        // setDashboardType('new');
        setSelectedGroupId([])
        setPintoDashboard(event.target.value);
    };
    useEffect(() => {
        fetchClientGroups()
    },[pintoDashboard])

    const handleSelectGroupChange = async (value) => {
        const selectedGroupId = value && value.length > 0 && value.map((item) => item.value)
        setSelectedGroupId(selectedGroupId);
    };
    
    const sendNotificationPerGroup = (isTemplateEdit, newDashboardName) => {
        if(selectedGroupId.includes(selectedClientID))
        {
            const usersSet = new Set();
            clientUsers.forEach(user => { if(user !== userDetails.User.Email) usersSet.add(user)});
            const msg = isTemplateEdit ? 
            `${userDetails.User.FirstName} ${userDetails.User.LastName} updated the ${newDashboardName} dashboard in ${selectedClient.Name} group` : 
            `${userDetails.User.FirstName} ${userDetails.User.LastName} posted new dashboard in ${selectedClient.Name} group`

            sendNotificationHandler(usersSet, msg, selectedClient.Name)
        }

        customGroupList && customGroupList.forEach(group => {
            const usersSet = new Set();
            if (selectedGroupId.includes(group.id) && group.UserList && group.UserList.users) {
                group.UserList.users.forEach(user => { if(user !== userDetails.User.Email) usersSet.add(user)});
                const msg = isTemplateEdit ? 
                `${userDetails.User.FirstName} ${userDetails.User.LastName} updated the ${newDashboardName} dashboard in ${group.GroupName}` :
                `${userDetails.User.FirstName} ${userDetails.User.LastName} posted a dashboard in ${group.GroupName}`

                sendNotificationHandler(usersSet, msg, group.GroupName)
            }
        });
    }

    const sendNotificationHandler = async (users, msg, groupName) => {
        sendNotification(users, msg)
        const ClientID = props.selectedClientID
        const notification = {
          title: `new notification from the "${groupName}" group`,
          body:  msg,
          sound: 'default',
          badge: '1',
        };
        
        const clientToken = await mongoFetchToken({ clientid : ClientID, groupId: selectedClientID })
        if(!clientToken) return 
        
        const filteredTokens = clientToken.tokens
        .filter(token => {
            return users.includes(token.email.toLowerCase()) && token.email.toLowerCase() !== userDetails.User.Email.toLowerCase();
        })
        .map(token => token.token);

        if (filteredTokens.length === 0) return
    
        const message = {
          tokens: filteredTokens,
          data: { ClientID: ClientID, Name: selectedClient.Name ,  type: 'custom group', Id: selectedClient.id},
          notification: notification,
        };

        SendMultiDeviceNotification(message)
        SendExpoNotifications(message)
    };

    const sendNotification = async (selectedUsers, message) => {
        // for (const email of selectedUsers) {
    
        //   if(email !== userDetails.User.Email)
        //   {
        //     const notifications = {
        //       uid: await generateUUID(),
        //       id: selectedClientID,
        //       clientId: selectedClientID,
        //       message: message,
        //       createdAt: new Date(),
        //       sender: userDetails.User.Email,
        //       isReport: true,
        //       email: email,
        //       user: email,
        //       url: '',
        //       groupId: selectedClientID,
        //     };
        //     // await socket.emit("newClientNotification", notifications);
        //     registerGroupNotification(notifications)
        //   }
        // }

        const filteredUserList = selectedUsers.filter( i => i != userDetails.User.Email)
        const notifications = {
            uid: await generateUUID(),
            id: selectedClientID,
            clientId: selectedClientID,
            message: message,
            createdAt: new Date(),
            sender: userDetails.User.Email,
            isReport: true,
            // email: email,
            // user: email,
            url: '',
            groupId: selectedClientID,
            receiverList: filteredUserList
        };
        try { 
            await registerGroupNotification(notifications)
            await socketServer.emit("newClientNotification", notifications);
        } catch (err) {

        }
      
       
    };
    const fileTypeImages = {
        XB: XBImage,
        XPM: XPMImage,
        WFM: WFMImage
    };
    const RenderIntegrationTemplates = ({tabKey, etaniTemplates}) => {
        const newTabKey = tabKey

        const newData = etaniTemplates && etaniTemplates.filter(template => template.name.trim().split("-")[1] && template.name.trim().split("-")[1] === newTabKey)

        return (
            newData.length > 0 ? 
            <div className='templateContainer' style={{ border: 'unset' }}>
                <Label htmlFor="newDashboardName" style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 7 }}>Templates</Label>
                <div className='templateContent'>
                    {etaniTemplates.length > 0 && etaniTemplates.map((template, index) => (
                        <React.Fragment key={template.id || index}>
                            {template.name.split("-")[1] && template.name.split("-")[1] === newTabKey && (
                                <div 
                                    style={{ 
                                        background: selectedEtaniTemplates?.id === template.id ? bgColor : undefined, 
                                        color: selectedEtaniTemplates?.id === template.id ? textColor : undefined 
                                    }}
                                    onClick={e => handleSelectEtaniTemplate(template)}
                                >
                                    {template.name.split("-")[0]}
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            : null
        )
    }
    const handleToggleShowSettings = () => {
        setToggleShowSettings(!toggleShowSettings)
    }

    const handleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        const results = [];

        const filteredData = sqlExampleResult.map((category) => {
            const newCategory = { ...category };
            newCategory.details = newCategory.details.map((subCategory) => {
                const newSubCategory = { ...subCategory };
                newSubCategory.details = newSubCategory.details.filter((item) =>
                    item.display_name.toLowerCase().includes(searchTerm)
                );
                return newSubCategory;
            }).filter(subCategory => subCategory.details.length > 0);
            return newCategory;
        }).filter(category => category.details.length > 0);
    
        setFilteredSQLExampleResult(filteredData);
    }
    const [isEtaniTemplate, setIsEtaniTemplate] = useState(false)
    const [selectedTemplateIntegration, setSelectedTemplateIntegration] = useState(null)
    const toggleEtaniTemplate = () => {
        setIsEtaniTemplate(!isEtaniTemplate)
    }
    const handleSelectIntegrationList = (event) => {
        setSelectedTemplateIntegration(event.target.value)
    }
    const EtaniTemplateSetting = () => {
        return (
            <>
            <Row>
                <Col className="d-flex mb-3" style={{ flexDirection: "column" }}>
                    <Label 
                        htmlFor="newDashboardName" 
                        style={{ 
                            fontWeight: 'bold', 
                            fontSize: 14, 
                            marginBottom: 7
                        }}>Is Etani Template?</Label>
                    <label className="custom-toggle custom-toggle-information mr-1">
                        <input
                            checked={isEtaniTemplate}
                            type="checkbox"
                            onChange={toggleEtaniTemplate}
                            id="mfa"
                            name="MFA"
                        />
                        <span
                        className="custom-toggle-slider rounded-circle"
                        data-label-off="No"
                        data-label-on="Yes"
                        />
                    </label>
                </Col>
            </Row>
            {isEtaniTemplate &&
                <Row>
                    <Col>
                        <FormGroup>
                            <Label 
                            htmlFor="selectedIntegrationId" 
                            style={{ 
                                fontWeight: 'bold', 
                                fontSize: 14, 
                                marginBottom: 7
                            }}>Select Integration</Label>
                            <Input type="select" id="selectedIntegrationId" value={selectedTemplateIntegration} onChange={handleSelectIntegrationList}>
                            <option value="">Select Integration</option>
                            {integrationList.map(integration => (
                                <option key={integration.id} value={integration.id}>
                                {integration.label}
                                </option>
                            ))}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
            }
            </>
        )
    }
    const integrationList = [
        {id: 'XB', label: 'Xero Blue'},
        {id: 'XPM', label: 'XPM'},
        {id: 'MYOB', label: 'MYOB AR Live'},
        {id: 'WFM', label: 'Workflow Max'}
    ]

    const [isEditDateRange, setIsEditDateRange] = useState(false)
    const [isToggleEVAModal, setIsToggleEVAModal] = useState(false)
    const [evaDashboardMessage, setEVADashboardMessage] = useState([])

    const handleEditDateRangeModal = (item, index) => {
        console.log({ item, index })
        setIsEditDateRange(!isEditDateRange)
    }
    const toggleEVAModal = () => {
        setIsToggleEVAModal(!isToggleEVAModal)
    }
    const handleSetDashboardName = (name) => {
        setNewDashboardName(name)
    }
    const clearDashboard = () => {
        setSelectedTemplateItem([]);
        setTemplateFinalSelectedTemplateItem([])
    }
    const handleChangeEVAUUID = async () => {
        const evaUUID = await generateUUID()
        setEVADashboardMessage([])
        setEVAUUID(evaUUID)
    }
    const handleEVADashboardMessage = (newMessage) => {
        setEVADashboardMessage(prev => [...prev, newMessage]);
    }
    const handleSelectTemplateItems = async (items) => {
        let newItems = [];

        for (const e of items) {
            const newItem = {
                uid: await generateUUID(),
                my_row_id: e.my_row_id,
                name: e.display_name,
                query: e.query,
                dynamic_query: e.dynamic_query,
                visual_type: e.visual_type,
                visual_data: e.visual_data,
                integration: e.integration
            };
            newItems.push(newItem);
        }
        
        setSelectedTemplateItem(prev => [...prev, ...newItems]);
    }
    const [isShowDashboardList, setIsShowDashboardList] = useState(false)
    const handleToggleShowDashboardList = () => {
        setIsShowDashboardList(!isShowDashboardList)
    }
    const handleCreateNewTample = () => {
        handleChangeTabIndex(2)
        sessionStorage.removeItem("selectedTemplatetoEdit");
        setTemplateFinalSelectedTemplateItem([])
        setIsTemplateEdit(false)
        setSelectedTemplatetoEdit(null)
        setSelectedTemplate(null)
        setSelectedTemplateItem([])
        setIshavechanges(false)
        setIsShowDashboardList(false)
    }
    const handleSelectDashboardTemplate = (dashboard) => {
        if(isHaveChanges) {
            handleConfirmChanges(dashboard)
        } else {
            sessionStorage.setItem("selectedTemplatetoEdit", JSON.stringify(dashboard));
            setTemplateFinalSelectedTemplateItem([])
            setIsTemplateEdit(true)
            setSelectedTemplatetoEdit(dashboard)
        }
    }

    useEffect(() => {
        try {
            const hasTemplateChanged = JSON.stringify(selectedTemplate || []) !== JSON.stringify(originalSelectedTemplateData || []);
            const hasTemplateItemsChanged = JSON.stringify(selectedTemplateItem || []) !== 
            JSON.stringify(originalSelectedTemplateData?.dashboardTemplate || []);
            let hasNameChanged = selectedTemplate?.name !== originalSelectedTemplateData?.name;
            const groupIdChanged = JSON.stringify(selectedGroupId || []) !== JSON.stringify(originalSelectedTemplateData?.selectedGroupId?.groupsId || []);

            let isLayoutChanged = false;
            const template = selectedTemplatetoEdit ? selectedTemplatetoEdit : templateFinalSelectedTemplateItem
            
            if(template) {  
                template.dashboardTemplate.forEach(item => {
                    if(JSON.stringify(item.visual) !== JSON.stringify(selectedTemplateItem.find(i => i.my_row_id === item.my_row_id)?.visual)) {
                        isLayoutChanged = true;
                    }
                })  

                hasNameChanged = template.name !== newDashboardName
            }

            // console.log({hasTemplateItemsChanged , hasTemplateChanged , hasNameChanged , groupIdChanged , isLayoutChanged})
            
            if (hasTemplateItemsChanged || hasTemplateChanged || hasNameChanged || groupIdChanged || isLayoutChanged) {
                setIshavechanges(true)
            } else {
                setIshavechanges(false)
            }
        } catch (error) {
            setIshavechanges(false)
        }
    }, [selectedTemplate, selectedTemplateItem, originalSelectedTemplateData, selectedGroupId, isLayoutChanges, newDashboardName]);

    const handleRevertChanges = () => {
        handleConfirmRevertChanges()
    }
    const handleSaveChanges = async () => {
        setShowBlockUI(true)
        setOriginalSelectedTemplateData(selectedTemplate)
        
        if (selectedTemplate.isPersonalDashboard) {
            const updatedUserDashboards = userAllDashboardList.map(dashboard => {
                if (dashboard.id === selectedTemplate.id) {
                    return {
                        ...dashboard,
                        ...selectedTemplate,
                        dashboardTemplate: selectedTemplateItem
                    };
                }
                return dashboard;
            });
            setContextUserAllDashboardList(updatedUserDashboards);
        } else {
            const updatedGroupDashboards = groupDashboardTemplatesList.map(dashboard => {
                if (dashboard.id === selectedTemplate.id) {
                    return {
                        ...dashboard,
                        ...selectedTemplate,
                        dashboardTemplate: selectedTemplateItem
                    };
                }
                return dashboard;
            });
            setContextGroupDashboardTemplatesList(updatedGroupDashboards);
        }
        if(pintoDashboard !== 'personal' && (selectedGroupId.length === 0 || !selectedGroupId))
        {
            warningAlert("Please select a Group!");
            return
        }

        if(isEtaniTemplate && !selectedTemplateIntegration) {
            warningAlert("Please select Integration!");
            return
        }

        const originalSelectedTemplateItem = templateFinalSelectedTemplateItem

        const dashboardItem = []
        selectedTemplateItem.map(item => {
            if(item.visual_type === 'Card') {
                const existingItem = originalSelectedTemplateItem.filter(i => i.my_row_id === item.my_row_id)
                if(existingItem) {
                    const item = existingItem[0]
                    if(item.tempVisual) {
                        
                        item.tempVisual.cardItem = existingItem.map(i => {
                            return {
                                ...i.tempVisual.cardItem[0],
                                x: i.tempVisual.x,
                                y: i.tempVisual.y,
                                width: i.tempVisual.width,
                                height: i.tempVisual.height
                            }
                        })
                        dashboardItem.push(item)
                    } else if(item.visual) {
                        item.visual.cardItem = existingItem.map(i => i.tempVisual.cardItem[0])
                        dashboardItem.push(item)
                    }
                }
            } else {
                dashboardItem.push(item)
            }
        })

        if(selectedTemplateItem.length > 0 && newDashboardName)
        {
            sessionStorage.removeItem("selectedTemplatetoEdit")
            let param = {
                name: isEtaniTemplate ? `${newDashboardName}-${selectedTemplateIntegration}` : newDashboardName,
                clientId: selectedClientID,
                businessId: firmDetails.AccountingFirmID,
                groupId: selectedClientID,
                user: userDetails.User.Email,
                isPersonalDashboard: isEtaniTemplate ? isEtaniTemplate : pintoDashboard === 'personal',
                selectedGroupId: { groupsId: selectedGroupId },
                isEtaniTemplate: isEtaniTemplate,
                isAllowEVAtoAnalyse: isAllowEVAtoAnalyse,
                dashboardTemplate: dashboardItem.map(item => ({
                    ...item,
                    visual: item.tempVisual || item.visual,
                    editedGridCellData: item.editedGridCellData
                })),
                uid: selectedEtaniTemplates?.uid ? selectedEtaniTemplates.uid : ''
            };
            
            param.dashboardTemplate.forEach(item => {
                delete item.tempVisual;
            });
            
            param.dashboardTemplate = param.dashboardTemplate.map(template => {
                return {
                    ...template,
                    query: template.final_dynamic_query || template.query,
                    final_dynamic_query: undefined,
                    dynamic_query: undefined
                };
            });
            
            param.dashboardTemplate = param.dashboardTemplate.map(({ final_dynamic_query, dynamic_query, query, ...rest }) => rest);
            sessionStorage.setItem("selectedTemplatetoEdit", JSON.stringify(param))

            if(isTemplateEdit)
            {
                param.id= selectedTemplatetoEdit.id
                await registerDashboardTemplate(param)
                if(pintoDashboard !== 'personal' && !isEtaniTemplate)
                    sendNotificationPerGroup(isTemplateEdit, newDashboardName)
                const alertMessage = `You have successfully update ${newDashboardName}`
                handleSaveChangesAlert(alertMessage)
            }else{
                await registerDashboardTemplate(param)
                const alertMessage = `You have successfully add ${newDashboardName}`
                if(pintoDashboard !== 'personal')
                    sendNotificationPerGroup(isTemplateEdit, newDashboardName)
                handleSaveChangesAlert(alertMessage)
            }

        }else{
            if (!selectedTemplateItem && selectedTemplateItem.length === 0) warningAlert("You need to add at least one item!");
            if (!newDashboardName) warningAlert("The dashboard name is invalid!");
        }

        setTemplateFinalSelectedTemplateItem([])
        setIshavechanges(false)
        setShowBlockUI(false)
    }
    const handleConfirmChanges = (dashboard) => {
        setAlert(
            <ReactBSAlert
                warning
                title="Warning"
                onConfirm={async () => {
                    setAlert(null)
                    sessionStorage.setItem("selectedTemplatetoEdit", JSON.stringify(dashboard));
                    setIsTemplateEdit(true)
                    setSelectedTemplatetoEdit(dashboard)
                }}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
                confirmBtnText="Proceed"
                cancelBtnText="Cancel"
                showCancel={true}
                showCloseButton={true}
                btnSize=""
            >
                <>
                    <p>
                        You have unsaved changes. Do you want to proceed to another dashboard templates?
                    </p>
                </>
            </ReactBSAlert>
        );
    }
    const handleConfirmRevertChanges = () => {
        setAlert(
            <ReactBSAlert
                warning
                title="Warning"
                onConfirm={async () => {
                    setAlert(null)
                    setShowBlockUI(true)
                    setSelectedTemplate(null)
                    setSelectedTemplateItem([])

                    const template = selectedTemplatetoEdit ? selectedTemplatetoEdit : templateFinalSelectedTemplateItem
                    const _originalSelectedTemplateData = originalSelectedTemplateData
                    // Update visuals in original template data by matching row IDs
                    template.dashboardTemplate.forEach(templateItem => {
                        const originalItem = _originalSelectedTemplateData.dashboardTemplate.find(
                            item => item.my_row_id === templateItem.my_row_id
                        );
                        if (originalItem) {
                            originalItem.tempVisual = templateItem.visual;
                            originalItem.visual = templateItem.visual;
                        }
                    });

                    setTimeout(() => {      
                        setSelectedTemplate(_originalSelectedTemplateData)
                        setSelectedTemplateItem(_originalSelectedTemplateData.dashboardTemplate)
                        setShowBlockUI(false)
                    }, 500)
                }}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
                confirmBtnText="Revert"
                cancelBtnText="Cancel"
                showCancel={true}
                showCloseButton={true}
                btnSize=""
            >
                <>
                    <p>
                        Are you sure you want to revert the changes?
                    </p>
                </>
            </ReactBSAlert>
        );
    }
    const handleSaveChangesAlert = (msg, data) => {
        setAlert(
            <ReactBSAlert
                succes
                title="Success"
                onConfirm={async () => {
                    setAlert(null)
                }}
                confirmBtnBsStyle="success"
                confirmBtnText="Ok"
                btnSize=""
            >
                <>
                    <p>
                        {msg}
                    </p>
                </>
            </ReactBSAlert>
        );
    }
    const handleLayoutChanges = () => {
        setIsLayoutChanges(prev => prev + 1)
    }
    const handleChangeTabIndex = (index) => {
        setActiveTabIndex(index)
    }
    const handleLoadEVAResponseToTemplate = async (message, stext, integration) => {
        const itemIndex = finalSelectedTemplateItem.length + 1
        const newItem = {
            "my_row_id": message.id * 1000,
            "name": `item ${itemIndex}`,
            "stext": stext,
            "visual_type": message?.visual?.selectedViewOption,
            // "visual_data": null,
            "integration": integration,
            "visual" : message?.visual
        }
        handleSelectItem(newItem)
    }
    const ref = useRef(null);
    const refLeft = useRef(null);
    const [resizeWidth, setResizeWidth] = useState(600)

    useEffect(() => {
        const resizeableEle = ref.current;
        if (!resizeableEle) return;
    
        const styles = window.getComputedStyle(resizeableEle);
        let width = parseInt(styles.width, 10);
        let height = parseInt(styles.height, 10);
        let x = 0;
    
        // resizeableEle.style.top = '50px';
        // resizeableEle.style.left = '50px';
    
        // Left resize
        const onMouseMoveLeftResize = (event) => {
            const dx = event.clientX - x;
            x = event.clientX;
            width = width - dx;
            resizeableEle.style.width = `${width}px`;
            setResizeWidth(width)
        };
    
        const onMouseUpLeftResize = () => {
            document.removeEventListener('mousemove', onMouseMoveLeftResize);
        };
    
        const onMouseDownLeftResize = (event) => {
            x = event.clientX;
            resizeableEle.style.right = styles.right;
            resizeableEle.style.left = null;
            document.addEventListener('mousemove', onMouseMoveLeftResize);
            document.addEventListener('mouseup', onMouseUpLeftResize);
        };
    
        // Add mouse down event listener
        const resizerLeft = refLeft.current;
        if (resizerLeft) {
            resizerLeft.addEventListener('mousedown', onMouseDownLeftResize);
        }
    
        return () => {
            if (resizerLeft) {
                resizerLeft.removeEventListener('mousedown', onMouseDownLeftResize);
            }
        };
    }, []);
    return (
        (userDetails?.User?.Details?.EvaEnabled || userDetails?.User?.UserAccess < 4) ?
        <div className="mt-6 fadeIn mainDashboard" style={{ height: windowHeight - 72 , overflow: 'hidden'}}>
            {showBlockUI ? <BlockUI /> : null}
            {alert}
            {isToggleEVAModal &&
                <EVAChatDashboard 
                    categories={categories}
                    sub_category={category_sub_category}
                    KPIList={KPIList}
                    selectedUUID={evaUUID}
                    evaDateFilters={evaDateFilters}
                    toggleEVAModal={toggleEVAModal}
                    onSelectUUID={handleChangeEVAUUID}
                    selectedTemplateItem={finalSelectedTemplateItem}
                    evaDashboardMessage={evaDashboardMessage}
                    handleEVADashboardMessage={handleEVADashboardMessage}
                    handleSelectTemplateItems={handleSelectTemplateItems}
                    handleSetDashboardName={handleSetDashboardName}
                />
            }
            {isShowDashboardList && <DashboardTemplateDashboardList
                isShowDashboardList={isShowDashboardList} 
                handleSelectDashboardTemplate={handleSelectDashboardTemplate}
                handleCreateNewTample={handleCreateNewTample}
            />}
            
            <div className="nav-wrapper dashboardTemplateContainer">

                {onEditVisual &&
                    <div className='onEditVisualContainer'>
                        <div className='onEditVisualContent'>
                            <EVAVisualEditDashboard
                                index={onEditItemIndex}
                                name={onEditItem.name}
                                query={evaQuery}
                                item={onEditItem}
                                selectedTemplateItem={finalSelectedTemplateItem}
                                onEditVisual={onEditVisual}
                                handleCloseEditVisual={handleCloseEditVisual}
                            />
                        </div>
                    </div>
                }


                <div className='templateListContainer' 
                    style={{ 
                        marginTop: 1, height: screenHeight - (isTemplateEdit ?  43 : 0) , background: '#f7f7f7', 
                        padding: 10, overflow: 'auto', paddingBottom: 100,
                        width: '100%',
                        paddingBottom: isShowDashboardList ? 400 : 100
                    }}>
                    <ManageDashboardDnD 
                        selectedTemplateItem={finalSelectedTemplateItem}
                        handleOnEditVisual={handleOnEditVisual}
                        onEditVisual={onEditVisual}
                        handleCloseEditVisual={handleCloseEditVisual}
                        newUpdateCount={newUpdateCount}
                        handleSelectItem={handleSelectItem}
                        handleEditDateRangeModal={handleEditDateRangeModal}
                        isEditDateRange={isEditDateRange}
                        evaDateFilters={evaDateFilters}
                        handleRemoveKPI={handleRemoveKPI}
                        handleLayoutChanges={handleLayoutChanges}
                        handleDateRangesUpdate={handleDateRangesUpdate}
                    />
                </div>
               
                <div className='templateListSettings' 
                    style={{ 
                        height: screenHeight - (!isTemplateEdit ? 72 : 72) , 
                        width: toggleShowSettings ? resizeWidth : 0, 
                        minWidth: toggleShowSettings ? 350 : 0, 
                        // display : toggleShowSettings ? 'block' : 'none'
                    }}>

                    <div className='templateListSettingContainer'>
                        <div className='toggleShowSettings' onClick={() => handleToggleShowSettings()}>
                            {toggleShowSettings ? 'Hide' : 'Show'} Menu
                        </div>
                    </div>

                  
                        <div className={`templateListContainer resizeable`} ref={ref}
                            style={{ 
                                height: screenHeight - (!isTemplateEdit ? 72 : 72),
                                paddingBottom: isShowDashboardList ? 317 : 0 , 
                                width: toggleShowSettings ? resizeWidth : 0,
                                minWidth: toggleShowSettings ? 350 : 0, 
                            }}>
                                    <div ref={refLeft} className="resizer resizer-l"></div>
                        {isLoading ? <CustomSpinner /> :
                            <>
                                {sqlExampleResult && sqlExampleResult.length > 0 ?
                                    <div className={`templateDashboardTabView  ${toggleShowSettings ? '' : 'hidden'}`}>
                                        <div className='templateDashboardTabViewHeader'>    
                                            <div className='templateDashboardTabViewHeaderItem'>
                                                <div className={`templateDashboardTabViewHeaderItemTitle ${activeTabIndex === 0 ? 'active' : ''}`} onClick={() => handleChangeTabIndex(0)}>
                                                    {/* <IconMenu stroke={activeTabIndex === 0 ? bgColor : '#525f7f'} /> */}
                                                    <IconFolder stroke='#333'/>
                                                    <span style={{ paddingTop: 2 }}>
                                                        Template Library
                                                    </span>
                                                </div>
                                                <div className={`templateDashboardTabViewHeaderItemTitle ${activeTabIndex === 1 ? 'active' : ''}`} onClick={() => handleChangeTabIndex(1)}>
                                                    {/* <IconBar2 stroke={activeTabIndex === 1 ? bgColor : '#525f7f'} /> */}
                                                    <IconAskEVA />
                                                    <span style={{ paddingTop: 2 }}>
                                                        Ask EVA
                                                    </span>
                                                </div>
                                                <div className={`templateDashboardTabViewHeaderItemTitle ${activeTabIndex === 2 ? 'active' : ''}`} onClick={() => handleChangeTabIndex(2)}>
                                                    {/* <IconBar2 stroke={activeTabIndex === 1 ? bgColor : '#525f7f'} /> */}
                                                    <IconBuilder />
                                                    <span style={{ paddingTop: 2 }}>Smart Builder</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='templateDashboardTabViewContent'>
                                            {activeTabIndex === 0 &&
                                                <>
                                                    {dashboardType === 'Existing' ? 
                                                        <div style={{ padding: '10px 10px', border: '1px solid #e0e0e0', borderTop: 'none', marginBottom: 10, paddingBottom: isShowDashboardList ? 310 : 0 }}>
                                                            {/* USER DASHBOARD */}
                                                            <div className='templateContainer' style={{ border: 'unset' }}>
                                                                <Label htmlFor="newDashboardName" style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 7 }}>Dashboards</Label>
                                                                {userTemplatesList.length > 0 ? 
                                                                    <div className='templateContent'>
                                                                            {userTemplatesList.map((item, index) => (
                                                                                <React.Fragment key={index}>
                                                                                    <div  key={index} style={{ background: selectedExistingDashboard === item.id && bgColor, color: selectedExistingDashboard === item.id && textColor }}
                                                                                        onClick={e => handleSelectExistingTemplate(item)}>
                                                                                        {item.name}
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            ))}
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        <div className='noTemplateFound'>
                                                                            No public dashboard template found!
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                            <div className="modal-footer">  
                                                                <CustomButton
                                                                    type="button"
                                                                    onClick={() => handleImportTemplate()}
                                                                    outlineStyle={false}
                                                                    title="Save"
                                                                />
                                                                <CustomButton
                                                                    onClick={() => {
                                                                        return history.push(`/client/customDashboard`);
                                                                    }}
                                                                    outlineStyle={true}
                                                                    data-dismiss="modal"
                                                                    type="button"
                                                                    color="link"
                                                                    title="Close"
                                                                /> 
                                                            
                                                            </div>
                                                        </div>
                                                    :
                                                        <div style={{ padding: '10px 10px', border: '1px solid #e0e0e0', borderTop: 'none', marginBottom: 10, position: 'relative' }}>
                                                                <Row>
                                                                    {includesEmail && 
                                                                        <Col>
                                                                            <EtaniTemplateSetting />
                                                                        </Col>
                                                                    }
                                                                    <Col xl='12'>
                                                                        <FormGroup>
                                                                            <Label 
                                                                                htmlFor="newDashboardName" 
                                                                                style={{ 
                                                                                    fontWeight: 'bold', 
                                                                                    fontSize: 14, 
                                                                                    marginBottom: 7
                                                                                }}>Dashboard Name</Label>
                                                                                <Input
                                                                                    key={1}
                                                                                    type="text"
                                                                                    id="newDashboardName"
                                                                                    placeholder="Dashboard Name"
                                                                                    value={newDashboardName}
                                                                                    onChange={handleNewDashboardNameChange}
                                                                                />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col xl='12'>
                                                                        <FormGroup>
                                                                            <CustomInput
                                                                                type="checkbox"
                                                                                id="allowEVAToAnalyse"
                                                                                name="allowEVAToAnalyse"
                                                                                value={isAllowEVAtoAnalyse}
                                                                                label="Allow EVA to Analyse data"
                                                                                checked={isAllowEVAtoAnalyse}
                                                                                onChange={() => setIsAllowEVAtoAnalyse(!isAllowEVAtoAnalyse)}
                                                                            />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col xl='12'>
                                                                        <FormGroup tag="fieldset">
                                                                            <Label 
                                                                                htmlFor="personalDashboard" 
                                                                                style={{ 
                                                                                    fontWeight: 'bold', 
                                                                                    fontSize: 14, 
                                                                                    marginBottom: 7
                                                                                }}>Dashboard Location</Label>
                                                                            <CustomInput
                                                                                type="radio"
                                                                                id="personalDashboard"
                                                                                name="pinTodashboardType"
                                                                                value="personal"
                                                                                label="Personal Dashboard"
                                                                                checked={pintoDashboard === 'personal'}
                                                                                onChange={handleSelectPinToDashboard}
                                                                            />
                                                                            <CustomInput
                                                                                type="radio"
                                                                                id="otherDashboard"
                                                                                name="pinTodashboardType"
                                                                                value="group"
                                                                                label="Group Dashboard"
                                                                                checked={pintoDashboard === 'group'}
                                                                                onChange={handleSelectPinToDashboard}
                                                                            />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col xl='12'>
                                                                        {pintoDashboard === 'group' && (
                                                                            <FormGroup>
                                                                                <Label 
                                                                                htmlFor="personalDashboard" 
                                                                                style={{ 
                                                                                    fontWeight: 'bold', 
                                                                                    fontSize: 14, 
                                                                                    marginBottom: 7
                                                                                }}>Group List</Label>
                                                                                <Select 
                                                                                    defaultValue={defaultSelectedGroup}
                                                                                    isMulti
                                                                                    name="colors"
                                                                                    options={groupList}
                                                                                    className="basic-multi-select"
                                                                                    classNamePrefix="select"
                                                                                    onChange={handleSelectGroupChange}
                                                                                />
                                                                            </FormGroup>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                                <div className="nav nav-tabs" role="tablist" style={{ border: `unset`}}>
                                                                    {integration && integration.map((item, index) => {
                                                                        const correspondingItem = selectClientIntegration.find(listItem => listItem.integration === item);
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <a 
                                                                                    id={correspondingItem?.id} 
                                                                                    href="#" 
                                                                                    role="tab" 
                                                                                    style={{
                                                                                        ...(tabKey === item ? { backgroundColor: bgColor, color: textColor } : { border: '1px solid #e0e0e0' }),
                                                                                        padding: '5px 10px 5px 4px'
                                                                                    }}
                                                                                    className={`nav-item nav-link ${tabKey === item ? "active" : ""}`}
                                                                                    onClick={() => handleTabSelect(item)}>
                                                                                        {item === "XB" || item === "XPM" ||item === "WFM"? 
                                                                                            <img src={fileTypeImages[item]} alt={`${item} logo`} style={{ height: 45, padding: 5 }} />
                                                                                        :
                                                                                            <img src={correspondingItem?.logo} alt={`${item} logo`} style={{ height: 45, padding: 5 }} />
                                                                                        }
                                                                                        
                                                                                        {item} Integration
                                                                                </a>
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                </div>
                                                                <div className='card-body' style={{ border: '1px solid #e0e0e0' , padding: '10px 10px',}}>
                                                                    {!isEtaniTemplate &&
                                                                        <Row>
                                                                            <Col xs='12'>
                                                                                <RenderIntegrationTemplates 
                                                                                    tabKey={tabKey}
                                                                                    etaniTemplates={etaniTemplates} />
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                    <Row>
                                                                    <Col sm="12">
                                                                        <InputGroup className="mb-4">
                                                                            <InputGroupAddon addonType="prepend">
                                                                                <InputGroupText>
                                                                                <i className="fas fa-search" />
                                                                                </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            <Input placeholder="Search KPI" type="text" onChange={handleSearch} />
                                                                        </InputGroup>
                                                                    </Col>
                                                                    </Row>
                                                                    <Row>
                                                                    {filteredSqlExampleResult && filteredSqlExampleResult.map((item, index) => (
                                                                        item.integration === tabKey && (
                                                                        <Col xs="12" key={index}>  {/* Added key={index} */}
                                                                            <div className="card">
                                                                            <DashboardTemplateKPI  
                                                                                index={index}
                                                                                categories={categories}
                                                                                sub_category={sub_category}
                                                                                tabKey={tabKey}
                                                                                item={item}
                                                                                selectedTemplateItem={finalSelectedTemplateItem}
                                                                                handleSelectItem={handleSelectItem}
                                                                                sqlExampleResult={sqlExampleResult}
                                                                                category={item.category}
                                                                                handleSelectCategory={handleSelectCategory}
                                                                            />
                                                                            </div>
                                                                        </Col>
                                                                        )
                                                                    ))}
                                                                    </Row>
                                                                </div>
                                                        </div>
                                                    }
                                                </> 
                                            }
                                            {activeTabIndex === 1 &&
                                                <div className='templateDashboardTabItem'>
                                                    <EVATemplates
                                                        handleLoadEVAResponseToTemplate={handleLoadEVAResponseToTemplate}
                                                        // handleNewUpdate={handleNewUpdate}
                                                        // selectedDashboardTemplate={selectedDashboardTemplate}
                                                        // handlePintoDashboardUpdate={handlePintoDashboardUpdate}
                                                    />
                                                </div>
                                            }
                                            {activeTabIndex === 2 &&
                                                <>
                                                    <EVAChatDashboard 
                                                        categories={categories}
                                                        sub_category={category_sub_category}
                                                        KPIList={KPIList}
                                                        selectedUUID={evaUUID}
                                                        evaDateFilters={evaDateFilters}
                                                        toggleEVAModal={toggleEVAModal}
                                                        onSelectUUID={handleChangeEVAUUID}
                                                        selectedTemplateItem={finalSelectedTemplateItem}
                                                        evaDashboardMessage={evaDashboardMessage}
                                                        handleEVADashboardMessage={handleEVADashboardMessage}
                                                        handleSelectTemplateItems={handleSelectTemplateItems}
                                                        handleSetDashboardName={handleSetDashboardName}
                                                    />
                                                </>
                                            }
                                        </div>
                                    </div>
                                :
                                    <>
                                        <div className="dashboardItems" style={{
                                            height: '200px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center', // Center horizontally
                                            justifyContent: 'center', // Center vertically
                                            flexWrap: 'wrap'
                                        }}>
                                            <div className="dashboardItemError" style={{color: '#9f9f9f'}}>No available templates for this client</div>
                                            <div className="dashboardItemError" style={{color: '#9f9f9f', fontSize: '13px', fontWeight: 400}}>Please check your integration status</div>
                                        </div>
                                    </>
                                }
                            </>
                        }
                        </div>
                
                </div>

                {/* {!toggleShowSettings && */}
                    <div className="toggle-modal-footer">
                        <div className='leftBtn '>
                            {!isShowDashboardList &&
                                <div style={{display: 'flex', alignItems: 'center', background: '#f0f0f0', padding: '0px 8px 0px 3px', borderRadius: 5}}>
                                    <IconDashboard stroke={'#262626'} />
                                    <span style={{fontSize: '15px', fontWeight: 'bold', color: '#333' }}>   {newDashboardName}</span>
                                </div>
                            }
                            {isTemplateEdit && !showBlockUI && isHaveChanges &&
                                <>
                                    <Button className='toggleShowSettings' color="primary" size="sm" outline type="button"  onClick={() => handleSaveChanges()}>
                                        Save Changes
                                    </Button>
                                    <Button className='toggleShowSettings' color="danger" size="sm" outline type="button"  onClick={() => handleRevertChanges()}>
                                        Revert Changes
                                    </Button>
                                </>
                            }
                        </div>
                        <div className='rightBtn'>
                            <Button color="danger" type="button" size='sm' onClick={() => {
                                    setTemplateFinalSelectedTemplateItem([])
                                    return history.push(`/client/customDashboard`);
                                }}>
                                Close
                            </Button>
                            <Button color="success" type="button" size='sm' onClick={() => handleSave()}>
                                Save & Close
                            </Button>
                            <div className='templateListSettingContainer' style={{ position: 'unset', transform: 'rotate(0deg)' }}>
                                <Button color={isShowDashboardList ? 'danger' : 'primary'} type="button" size='sm' onClick={() => handleToggleShowDashboardList()}>
                                    {isShowDashboardList ? ' Hide' : 'Show'} Dashboard List
                                </Button>
                               
                                {selectedTemplateItem && selectedTemplateItem.length > 0 &&
                                    <Button color="warning" type="button" size='sm' outline onClick={() => clearDashboard()}>
                                        Clear Dashboard
                                    </Button>
                                }
                                {isTemplateEdit &&
                                    <Button color="success" type="button" size='sm' onClick={() => handleCreateNewTample()}>
                                        Create New
                                    </Button>
                                }
                            </div>
                        </div>
                    </div> 
                {/* } */}
            </div>
        </div>
        : 
        <div className="mt-6 fadeIn mainDashboard" style={{ height: windowHeight - 72 , overflow: 'hidden', padding: '0px 15px'}}>
           <div class="nav-wrapper">
                <div class="card">
                    <div class="row">
                        <div class="text-center p-5 col">
                            <span>You currently do not have access to view this page. Please contact your administrator or advisor to request EVA access.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardTemplate